// Scroll-based TOC active state for GeoIP article pages
const initTocHighlight = (): void => {
  const tocContainer = document.querySelector('.js-geoip-article__toc');
  if (!tocContainer) return;

  const tocLinks = tocContainer.querySelectorAll('a');
  const headings: HTMLElement[] = [];

  // Collect all headings referenced by TOC links
  tocLinks.forEach((link) => {
    const href = link.getAttribute('href');
    if (!href) return;
    const hashIndex = href.indexOf('#');
    if (hashIndex === -1) return;
    const id = href.substring(hashIndex + 1);
    const heading = document.getElementById(id);
    if (heading) headings.push(heading);
  });

  if (headings.length === 0) return;

  const setActiveLink = (activeId: string): void => {
    tocLinks.forEach((link) => {
      const li = link.parentElement;
      if (!li) return;
      const href = link.getAttribute('href') || '';
      const hashIndex = href.indexOf('#');
      const linkId = hashIndex !== -1 ? href.substring(hashIndex + 1) : '';
      if (linkId === activeId) {
        li.classList.add('active');
      } else {
        li.classList.remove('active');
      }
    });
  };

  const updateActiveHeading = (): void => {
    // Offset from top of viewport to consider a heading "active"
    // Should be slightly larger than the header height (~78px) plus some buffer
    const offset = 125;

    // Find the heading that's currently at or above the offset
    let activeHeading = headings[0];
    for (const heading of headings) {
      const rect = heading.getBoundingClientRect();
      if (rect.top <= offset) {
        activeHeading = heading;
      } else {
        break;
      }
    }

    if (activeHeading?.id) {
      setActiveLink(activeHeading.id);
    }
  };

  // Run on load and scroll
  updateActiveHeading();
  window.addEventListener('scroll', updateActiveHeading, { passive: true });
};

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTocHighlight);
} else {
  initTocHighlight();
}
